export enum GlCurrencyTypeEnum {
  LOCAL = 'LOCAL',
  FOREIGN = 'FOREIGN',
  ANY = 'ANY',
}
